import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const { language, t, toggleLanguage } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const navItems = [
    { id: 'home', label: t.nav.home },
    { id: 'lunch', label: t.nav.lunch },
    { id: 'about', label: t.nav.about },
    { id: 'contact', label: t.nav.contact }
  ];

  const bgClass = scrolled || !isHome
    ? 'bg-[#FAF6F0]/95 backdrop-blur-md shadow-sm border-b border-[#E8DFCF]'
    : 'bg-transparent';
  const textClass = scrolled || !isHome ? 'text-[#1F2A24]' : 'text-white';

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${bgClass}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img
            src="/logo.svg"
            alt="Ravintola La Maria"
            className={`h-12 md:h-14 w-auto transition-all ${scrolled || !isHome ? '' : 'drop-shadow-[0_4px_12px_rgba(0,0,0,0.45)]'}`}
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {isHome && navItems.map(item => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`text-sm font-medium tracking-wide hover:text-[#B8934A] transition-colors ${textClass}`}
            >
              {item.label}
            </button>
          ))}
          <div className={`flex items-center gap-2 pl-4 border-l ${scrolled || !isHome ? 'border-[#E8DFCF]' : 'border-white/30'}`}>
            <button
              onClick={() => toggleLanguage('fi')}
              className={`text-xs font-bold tracking-wider px-2 py-1 rounded transition-colors ${language === 'fi' ? 'text-[#B8934A]' : (scrolled || !isHome ? 'text-[#6B6257] hover:text-[#1F2A24]' : 'text-white/70 hover:text-white')}`}
            >FI</button>
            <span className={`text-xs ${scrolled || !isHome ? 'text-[#B8A994]' : 'text-white/40'}`}>|</span>
            <button
              onClick={() => toggleLanguage('en')}
              className={`text-xs font-bold tracking-wider px-2 py-1 rounded transition-colors ${language === 'en' ? 'text-[#B8934A]' : (scrolled || !isHome ? 'text-[#6B6257] hover:text-[#1F2A24]' : 'text-white/70 hover:text-white')}`}
            >EN</button>
          </div>
        </nav>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`lg:hidden ${textClass}`}
          aria-label="menu"
        >
          {mobileOpen ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-[#FAF6F0] border-t border-[#E8DFCF] shadow-lg">
          <div className="px-6 py-4 flex flex-col gap-3">
            {isHome && navItems.map(item => (
              <button
                key={item.id}
                onClick={() => scrollTo(item.id)}
                className="text-left py-2 text-[#1F2A24] font-medium hover:text-[#B8934A]"
              >{item.label}</button>
            ))}
            <div className="flex items-center gap-3 pt-3 border-t border-[#E8DFCF]">
              <button onClick={() => toggleLanguage('fi')} className={`text-sm font-bold px-3 py-1 rounded ${language === 'fi' ? 'bg-[#7A1F25] text-white' : 'bg-[#F0E9DC] text-[#1F2A24]'}`}>FI</button>
              <button onClick={() => toggleLanguage('en')} className={`text-sm font-bold px-3 py-1 rounded ${language === 'en' ? 'bg-[#7A1F25] text-white' : 'bg-[#F0E9DC] text-[#1F2A24]'}`}>EN</button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
